const { EXPLORE_ACTIONS, EXPLORE_ACTIONS_WITHOUT_YEAR } = require('./constants');

const explorePermissions = (action, permissions, year) => {
  if (
    action.startsWith('explore:') &&
    permissions.some((item) =>
      ['DATAPOINTS_DEVELOPER', 'THE_STAFF_ACCESS_ALL_INSTITUTIONS'].includes(
        item,
      ),
    )
  ) {
    return true;
  }

  if (
    action === 'explore:viewRelease' &&
    permissions.includes(`DATAPLUS_ADVANCED_${year}`)
  ) {
    return true;
  }

  if (
    EXPLORE_ACTIONS.some((exploreAction) => action === exploreAction) &&
    permissions.some((item) =>
      [`DATAPLUS_ADVANCED_${year}`, `DATAPLUS_COMPREHENSIVE_${year}`].includes(
        item,
      ),
    )
  ) {
    return true;
  }

  if (
    EXPLORE_ACTIONS_WITHOUT_YEAR.some((exploreAction) => action === exploreAction) &&
    permissions.some((item) =>
      item.includes('DATAPLUS_ADVANCED') || item.includes('DATAPLUS_COMPREHENSIVE')
    )
  ) {
    return true;
  }

  return false;
};

module.exports = {
  explorePermissions,
};
